import { useState } from 'react'
import { useFinance } from '../context/FinanceContext'
import { useSettings } from '../context/SettingsContext'
import { getThemeColors } from '../lib/constants'
import { trackCalculatorUse } from '../lib/analytics'
import PageShell from '../components/layout/PageShell'
import LoanCalculator from '../components/scenarios/LoanCalculator'
import ComparisonTool from '../components/scenarios/ComparisonTool'
import DebtPayoff from '../components/scenarios/DebtPayoff'
import DebtVsInvest from '../components/scenarios/DebtVsInvest'

const TABS = [
  { key: 'loans', label: 'Loan Calculator', icon: LoanIcon },
  { key: 'compare', label: 'Compare', icon: CompareIcon },
  { key: 'debt', label: 'Debt Payoff', icon: DebtIcon },
  { key: 'debtvsinvest', label: 'Debt vs Invest', icon: DebtVsInvestIcon },
]

export default function LoansDebt() {
  const { state } = useFinance()
  const { trackCalculatorOpen } = useSettings()
  const colors = getThemeColors(state.theme)
  const validTabs = TABS.map(t => t.key)
  const [activeTab, setActiveTab] = useState(validTabs.includes(state.activeTab) ? state.activeTab : 'loans')

  return (
    <PageShell
      title="Loans & Debt"
      subtitle="Loan calculators, debt payoff strategies, and side-by-side comparisons"
    >
      {/* Tabs */}
      <div className="flex gap-1 p-1 rounded-2xl glass mb-6 max-w-fit">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => { setActiveTab(key); trackCalculatorUse(key); trackCalculatorOpen(key) }}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
              activeTab === key
                ? 'text-heading shadow-sm'
                : 'text-muted hover:text-heading'
            }`}
            style={activeTab === key ? {
              background: `linear-gradient(135deg, ${colors.primary}22, ${colors.secondary}22)`,
              border: `1px solid ${colors.primary}33`,
            } : {}}
          >
            <Icon active={activeTab === key} />
            <span className="hidden sm:inline">{label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="animate-fade-in">
        {activeTab === 'loans' && <LoanCalculator />}
        {activeTab === 'compare' && <ComparisonTool />}
        {activeTab === 'debt' && <DebtPayoff />}
        {activeTab === 'debtvsinvest' && <DebtVsInvest />}
      </div>
    </PageShell>
  )
}

function LoanIcon({ active }) {
  return (
    <svg className="w-4 h-4" style={active ? { color: 'var(--primary)' } : {}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
    </svg>
  )
}

function CompareIcon({ active }) {
  return (
    <svg className="w-4 h-4" style={active ? { color: 'var(--primary)' } : {}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
    </svg>
  )
}

function DebtIcon({ active }) {
  return (
    <svg className="w-4 h-4" style={active ? { color: 'var(--primary)' } : {}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
    </svg>
  )
}

function DebtVsInvestIcon({ active }) {
  return (
    <svg className="w-4 h-4" style={active ? { color: 'var(--primary)' } : {}} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
    </svg>
  )
}
